(function($) {

    // Cancel order AJAX
    $("a.myacc-orders__item_action.cancel").on('click', function(e){
        e.preventDefault()

        if (confirm(scripts_translations.my_account.order.confirm_cancel)) {

            const url = ghostpress_params.ajax_url + "&action=cancel_order"
            const order_number = $(this).attr('data-order_number')
            const order_key = $(this).attr('data-order_key')

            if (order_number && order_key) {
                gp_ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    data: {
                        order_number: order_number,
                        order_key: order_key,
                    },
                    show_loading: true
                })
                    .done((response) => {
                        if (response.success) {
                            alert(scripts_translations.my_account.order.cancel_success)
                        }
                        else {
                            alert(scripts_translations.my_account.order.cancel_error)
                        }
                        window.location.reload()
                    })
            }
        }
    })

})(jQuery);